import script from "./ParticleField.vue?vue&type=script&setup=true&lang=js"
export * from "./ParticleField.vue?vue&type=script&setup=true&lang=js"

import "./ParticleField.vue?vue&type=style&index=0&id=0afeea90&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4ec47925de61d4228d9226091d28bf74/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0afeea90"]])

export default __exports__